export default function Method() {
  const steps = [
    {
      number: '01',
      title: 'Assess',
      description: 'Comprehensive operational audit to identify bottlenecks and opportunities'
    },
    {
      number: '02',
      title: 'Design',
      description: 'Strategic system architecture aligned with your business goals'
    },
    {
      number: '03',
      title: 'Implement',
      description: 'Structured deployment of intelligent automation workflows'
    },
    {
      number: '04',
      title: 'Optimize',
      description: 'Continuous monitoring and performance improvement'
    }
  ];

  return (
    <section className="py-32 px-8 bg-[#F5F5F7]">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-5xl md:text-6xl font-light text-[#0E1A2B] mb-20 text-center tracking-tight">
          The Method
        </h2>
        
        <div className="space-y-16">
          {steps.map((step, index) => (
            <div key={index} className="flex items-start gap-8">
              <div className="flex-shrink-0">
                <div className="w-16 h-16 rounded-full border-2 border-[#28D7C6] flex items-center justify-center">
                  <span className="text-xl font-light text-[#28D7C6]">{step.number}</span>
                </div>
              </div>
              <div className="pt-3">
                <h3 className="text-3xl font-medium text-[#0E1A2B] mb-3 tracking-tight">
                  {step.title}
                </h3>
                <p className="text-xl font-light text-[#5C6675] leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}